"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const intl_1 = require("@kyruus/intl");
const types_1 = require("@kyruus/types");
const provider_components_1 = require("@kyruus/provider-components");
const messages_1 = __importDefault(require("../../lib/messages"));
const network_affiliations_styles_1 = require("./network-affiliations-styles");
const styles_1 = require("../ProviderHighlights/styles");
const utils_1 = require("../../lib/utils");
const with_error_boundary_1 = require("../ErrorFallback/with-error-boundary");
const ProviderNetworkAffiliations = ({ intl, provider, config, shouldSkipRender }) => {
    var _a;
    // prune ignored network_affiliations off the provider object
    const prunedProvider = (0, utils_1.pruneIgnoredNetworkAffiliations)(provider, config);
    // only display logos that are mapped to network_affiliations field values
    const networkAffiliationsLogos = (config.logos_v9 || []).filter((logoConfig) => logoConfig.field === 'network_affiliations');
    const providerLogos = (0, react_1.useMemo)(() => (0, provider_components_1.getProviderLogoObjects)(prunedProvider, networkAffiliationsLogos, config.facets_v9 || [], types_1.PMCLogoSections.PROFILE), [prunedProvider, networkAffiliationsLogos, config]);
    const hasLogos = providerLogos.length > 0;
    const skipRendering = !(0, utils_1.isSummaryDataConfigured)('network_affiliations', config) ||
        (!((_a = prunedProvider.network_affiliations) === null || _a === void 0 ? void 0 : _a.length) && !hasLogos);
    (0, react_1.useEffect)(() => {
        if (skipRendering) {
            // callback to the parent component to skip rendering
            shouldSkipRender('network-affiliations');
        }
    }, [skipRendering]);
    if (skipRendering) {
        return null;
    }
    return (react_1.default.createElement(styles_1.ProviderAffiliationsCard, { id: 'info-card-network-affiliations', "data-testid": 'info-card-network-affiliations' },
        react_1.default.createElement(styles_1.CardContentHeader, null, intl.formatMessage(messages_1.default.profileNetworkAffiliationsHeader)),
        react_1.default.createElement(network_affiliations_styles_1.NetworkAffiliationsList, { hasLogos: hasLogos }, prunedProvider.network_affiliations.map(({ name }, index) => (react_1.default.createElement(network_affiliations_styles_1.NetworkAffiliationsListItem, { hasLogos: hasLogos, key: name + index }, name)))),
        react_1.default.createElement(network_affiliations_styles_1.LogosContainer, null,
            react_1.default.createElement(provider_components_1.ProviderLogos, { provider: prunedProvider, logoConfigs: networkAffiliationsLogos, facets: config.facets_v9, logoSection: types_1.PMCLogoSections.PROFILE, isVertical: false }))));
};
exports.default = (0, with_error_boundary_1.withErrorBoundary)((0, intl_1.injectIntl)(ProviderNetworkAffiliations));
//# sourceMappingURL=network-affiliations.js.map